import Video1 from "./video1";
import Video2 from "./video2";


export default function Video({ options, data }) {
    
    const type = options.type ;

    if(type === 1) {
        return <Video1 
            options={options}
            data={data}
        />
    }

    if(type === 2) {
        return <Video2 
            options={options}
            data={data}
        />
    }

    return <></>
}